class Options {
  classBackground!: string; // 기본 배경 ClassName
  classBackgroundOpacity!: string; // 투명 배경 ClassName
  applyRouter!: string[]; // 해당 효과를 적용할 라우터
  triggerOffset?: number = 300; // y offset, 효과가 일어날 위치
}

export class Gnb {
  private _options: Options;
  private _el?: HTMLElement;

  constructor(options: Options) {
    this._options = Object.assign(new Options(), options);
  }

  private changeBackground(flag: 'normal' | 'opacity') {
    const el = this._el!;
    const normal = this._options.classBackground;
    const opacity = this._options.classBackgroundOpacity;

    if (flag === 'normal') {
      el.classList.add(normal);
      el.classList.remove(opacity);
    }

    if (flag === 'opacity') {
      el.classList.add(opacity);
      el.classList.remove(normal);
    }
  }
  private eventScroll = () => {
    if (window.pageYOffset < this._options.triggerOffset!) this.changeBackground('opacity');
    else this.changeBackground('normal');
  };

  private eventMouseOver = () => window.pageYOffset < this._options.triggerOffset! && this.changeBackground('normal');
  private eventMouseOut = () => window.pageYOffset < this._options.triggerOffset! && this.changeBackground('opacity');

  private addEvent() {
    addEventListener('scroll', this.eventScroll);
    this._el?.addEventListener('mouseover', this.eventMouseOver);
    this._el?.addEventListener('mouseout', this.eventMouseOut);
    this.changeBackground('opacity');
  }
  private removeEvent() {
    removeEventListener('scroll', this.eventScroll);
    this._el?.removeEventListener('mouseover', this.eventMouseOver);
    this._el?.removeEventListener('mouseout', this.eventMouseOut);
    this.changeBackground('normal');
  }

  applyByPath(path: string) {
    const applyList = this._options.applyRouter;
    if (!applyList.includes(path)) return this.removeEvent();
    this.addEvent();
  }
  /**
   * 라이프사이클 상, mounted 훅에서 실행되어야 nav 엘레먼트를 받을 수 있습니다.
   */
  init(el: HTMLElement) {
    if (!el) throw new Error('Gnb Element is not defined');
    this._el = el;
  }
}
